import React from 'react';
import { Wrapper } from './AccountDropdownItem.style';

interface DropdownItemProps {
  label: React.ReactNode;
  link: string;
}
export const AccountDropdownItem: React.FC<DropdownItemProps> = ({
  label,
  link,
}) => {
  return (
    <Wrapper>
      <a href={link}>{label}</a>
    </Wrapper>
  );
};
